import popupCloseIcon from "../../assests/page/popup-close-icon.svg";
import expandIcon from "../../assests/page/chevron-right-icon.svg";
import backIcon from "../../assests/page/chevron-left.svg";
import notificationIcon from "../../assests/page/notifications.svg";
import settingsIcon from "../../assests/page/settings.svg";
import profilePicture from "../../assests/page/profile-picture.svg";
import accountIcon from "../../assests/page/account-balance-icon.svg";
import walletIcon from "../../assests/page/account-balance-wallet-icon.svg";
import demographyIcon from "../../assests/page/demography-icon.svg";
import debitCard from "../../assests/page/debit-card.svg";
import friends from "../../assests/page/friends.svg";
import aboutIcon from "../../assests/page/quick_reference.svg";
import questions from "../../assests/page/shield_question.svg";
import profilePictureBig from "../../assests/page/profile-picture-large.svg";
import editIcon from "../../assests/page/profile-pic-edit.svg";
import verifiedIcon from "../../assests/page/verified-checkmark.svg";
import keyIcon from "../../assests/page/key_vertical.svg";
import copyIcon from "../../assests/page/content_copy.svg";
import coSignersIcon from "../../assests/page/co-signers.svg";
import lockIcon from "../../assests/page/lock.svg";
import phoneIcon from "../../assests/page/phone.svg";
import logoutIcon from "../../assests/page/logout-red.svg";
import deleteIcon from "../../assests/page/delete-red.svg";
import overlayVector from "../../assests/page/overlay-vector.svg";
import visaIcon from "../../assests/page/visa-icon.svg";
import exposeCvvIcon from "../../assests/page/expose-icon.svg";
import hideCvvIcon from "../../assests/page/hide-cvv-icon.svg";
import toggleActive from "../../assests/page/Toggle-active.svg";
import ethereumIcon from "../../assests/overlay/ethereum-icon.svg";
import toggle from "../../assests/page/Toggle.svg";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import ProfilePin from "./profilePin";
import ProfileEditContact from "./profileEditContact";
import ProfileEditCountry from "./profileEditCountry";
import ProfileCoSigner from "./profileCoSigner";
import ProfileChangePin from "./profileChangePin";
import GeneralPopupBackground from ".";
import hexTrustIconBlue from "../../assests/page/hextrusticonblue.jpg";
import verifiedLogo from "../../assests/page/icon128.png";
import walletConnectIcon from "../../assests/page/wallet-connect-icon.webp";
import Avatar from "react-avatar";
import { useAppKit, useWalletInfo } from "@reown/appkit/react";
import { wagmiAdapter } from "../..";
import { SwitchNetwork } from "./network";
import { chainDetails } from "../../utils/config";
import useNetworkStore from "../../store/networkStore";
import useUserStore from "../../store/userSlice";
import { useAccount, useDisconnect } from "wagmi";
import { disconnect as disconnectCore } from "@wagmi/core";
import { useWalletSelector } from "@near-wallet-selector/react-hook";
import nearIcon from "../../assests/overlay/near-icon.svg";
import {
  capitalizeFirstLetter,
  showCustomAlert,
} from "../../utils/helpers/utils";
import { useConnector } from "@solana-commerce/connector";
import solanaIcon from "../../assests/overlay/solana-logo.svg";
import StartupLanguagePage from "../../pages/ftu/language";
import { getCurrentLanguage, getCurrentLanguageRaw } from "../../lib/i18n";

const ProfilePopup = (props) => {
  const [showProfileDetails, setShowProfileDetails] = useState(
    props.showProfileDetails || false,
  );
  const [customPortal, setCustomPortal] = useState(props.customPortal || "");
  const { address, connector } = useAccount();
  const { disconnect } = useDisconnect();
  const { signedAccountId, wallet, signOut } = useWalletSelector();
  const {
    selectedWallet,
    accounts,
    disconnect: disconnectSol,
  } = useConnector();

  const {
    userAddress,
    userFullName,

    userEmail,
    userCountry,

    userRole,
    userKycStatus,
    userImageLink,
    userType,
    isConnected,
    resetUser,
  } = useUserStore();

  const {
    custodyWalletDetails,
    verifiedWalletDetails,
    setVerifiedWalletDetailsInt,
  } = props.generalDataProps;

  const { chainId, resetNetwork } = useNetworkStore();

  const navigate = useNavigate();

  const [language, setLanguage] = useState("English (en)");
  const [refereshLanguage, setRefereshLanguage] = useState(false);

  useEffect(() => {
    const getLanguage = async () => {
      setLanguage(await getCurrentLanguage());
    };

    getLanguage();
  }, [refereshLanguage]);

  return (
    <React.Fragment>
      <div className="search-filter-popup">
        <div className="search-filter-popup-content">
          <div className="asset-info-popup-header">
            <div className="asset-info-popup-header-main">
              <div className="asset-info-popup-header-main-text">
                {showProfileDetails && (
                  <img
                    onClick={() => {
                      setShowProfileDetails(false);
                    }}
                    className="profile-popup-icon"
                    alt="Back Icon"
                    src={backIcon}
                  />
                )}
                {!showProfileDetails && (
                  <React.Fragment>
                    {customPortal === "" && (
                      <p className="search-filter-popup-header-text">Profile</p>
                    )}
                    {customPortal === "settings" && (
                      <React.Fragment>
                        <img
                          onClick={() => {
                            setCustomPortal("");
                          }}
                          className="profile-popup-icon"
                          alt="Back Icon"
                          src={backIcon}
                        />
                        <p className="search-filter-popup-header-text">
                          Account Settings
                        </p>
                      </React.Fragment>
                    )}
                    {customPortal === "card" && (
                      <React.Fragment>
                        <img
                          onClick={() => {
                            setCustomPortal("");
                          }}
                          className="profile-popup-icon"
                          alt="Back Icon"
                          src={backIcon}
                        />
                        <p className="search-filter-popup-header-text">
                          Card Settings
                        </p>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
                {showProfileDetails && (
                  <p className="search-filter-popup-header-text">
                    Profile Details
                  </p>
                )}
              </div>
              <div className="asset-info-popup-icons">
                {!showProfileDetails && (
                  <>
                    {customPortal === "" && (
                      <>
                        <img
                          onClick={() => {
                            setCustomPortal("settings");
                          }}
                          className="profile-popup-icon"
                          alt="Close Icon"
                          src={settingsIcon}
                        />
                      </>
                    )}
                  </>
                )}
                <img
                  onClick={() => {
                    props.setPopupContentPosition("center");
                    props.setPopupContent(null);
                    if (props.setFavouriteClicked) {
                      props.setFavouriteClicked(false);
                    }
                    props.setShowPopup(false);
                    navigate(
                      window.location.href
                        .replace(window.location.search, "")
                        .replace(window.location.origin, ""),
                    );
                  }}
                  className="profile-popup-icon"
                  alt="Close Icon"
                  src={popupCloseIcon}
                />
              </div>
            </div>
          </div>

          <div
            style={
              customPortal === "card" ? { gap: "20px", overflow: "auto" } : {}
            }
            className="profile-popup-content"
          >
            {!showProfileDetails && (
              <React.Fragment>
                {customPortal === "" && (
                  <React.Fragment>
                    <div
                      onClick={() => {
                        setShowProfileDetails(true);
                      }}
                      className="profile-popup-content-first"
                    >
                      <div className="profile-popup-content-first-container">
                        <div className="profile-popup-content-first-icon">
                          {userImageLink.length > 0 && (
                            <img src={userImageLink} alt="Profile Icon" />
                          )}
                          {userImageLink === "" && (
                            <Avatar
                              name={userFullName.replace("undefined", "")}
                            />
                          )}
                        </div>
                        <div className="profile-popup-content-first-text-container">
                          {userFullName.replace("undefined", "").length > 0 && (
                            <p className="profile-popup-content-first-text-title">
                              {userFullName.replace("undefined", "")}
                            </p>
                          )}

                          {userFullName === "" && (
                            <p className="profile-popup-content-first-text-title">
                              No Name
                            </p>
                          )}

                          <p className="profile-popup-content-first-text-label">
                            Profile Details
                          </p>
                        </div>
                      </div>
                      <img src={expandIcon} alt="Expand Icon" />
                    </div>

                    <div className="profile-popup-content-third">
                      <p className="profile-popup-content-second-text">Chain</p>
                      <div className="profile-popup-content-third-content-line"></div>
                      <div className="profile-popup-content-third-container">
                        <div className="profile-popup-content-third-content">
                          {!signedAccountId && accounts?.length === 0 && (
                            <div className="profile-popup-content-third-content-text-container">
                              {chainDetails[Number(chainId)]?.icon && (
                                <img
                                  style={{
                                    maxHeight: "30px",
                                    maxWidth: "30px",
                                    overflow: "hidden",
                                    borderRadius: "40px",
                                  }}
                                  src={chainDetails[Number(chainId)]?.icon}
                                  alt=""
                                />
                              )}
                              <p className="profile-popup-content-third-content-text">
                                {wagmiAdapter?.wagmiChains?.find(
                                  (chn) => chn.id === chainId,
                                )?.name || chainDetails[Number(chainId)]?.name}
                              </p>
                            </div>
                          )}

                          {signedAccountId?.length > 0 &&
                            accounts?.length === 0 && (
                              <div
                                style={{ width: "100%" }}
                                className="profile-popup-content-third-content-text-container"
                              >
                                <img
                                  style={{
                                    maxHeight: "30px",
                                    maxWidth: "30px",
                                    overflow: "hidden",
                                    borderRadius: "40px",
                                  }}
                                  src={nearIcon}
                                  alt=""
                                />
                                <p
                                  style={{ minWidth: "70%" }}
                                  className="profile-popup-content-third-content-text"
                                >
                                  Near{" "}
                                  {process.env.REACT_APP_NODE_ENV ===
                                  "production"
                                    ? "Mainnet"
                                    : "Testnet"}
                                </p>
                              </div>
                            )}
                          {!signedAccountId &&
                            accounts[0]?.address?.length > 0 && (
                              <div
                                style={{ width: "100%" }}
                                className="profile-popup-content-third-content-text-container"
                              >
                                <img
                                  style={{
                                    maxHeight: "30px",
                                    maxWidth: "30px",
                                    overflow: "hidden",
                                    borderRadius: "40px",
                                  }}
                                  src={solanaIcon}
                                  alt=""
                                />
                                <p
                                  style={{ minWidth: "70%" }}
                                  className="profile-popup-content-third-content-text"
                                >
                                  Solana
                                </p>
                              </div>
                            )}
                          {!signedAccountId && accounts?.length === 0 && (
                            <button
                              onClick={() => {
                                props.setFavouriteClicked(false);
                                props.setPopupContentPosition("center");
                                props.setPopupContent(
                                  <SwitchNetwork
                                    setShowPopup={props.setShowPopup}
                                    setPopupContent={props.setPopupContent}
                                    setPopupContentPosition={
                                      props.setPopupContentPosition
                                    }
                                    setFavouriteClicked={
                                      props.setFavouriteClicked
                                    }
                                    setCustomLoading={props.setCustomLoading}
                                    verifiedWalletDetails={
                                      props.verifiedWalletDetails
                                    }
                                    setVerifiedWalletDetails={
                                      props.setVerifiedWalletDetails
                                    }
                                    custodyWalletDetails={
                                      props.custodyWalletDetails
                                    }
                                    generalDataProps={props.generalDataProps}
                                  />,
                                );
                                props.setShowPopup(true);
                              }}
                              className="profile-popup-content-third-button"
                            >
                              <p className="profile-popup-content-third-button-text">
                                Switch
                              </p>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    {isConnected && (
                      <div className="profile-popup-content-third">
                        <p className="profile-popup-content-second-text">
                          Connector
                        </p>
                        <div className="profile-popup-content-third-content-line"></div>
                        <div className="profile-popup-content-third-container">
                          <div className="profile-popup-content-third-content">
                            {!signedAccountId && accounts?.length === 0 && (
                              <div className="profile-popup-content-third-content-text-container">
                                {Object.keys(custodyWalletDetails)?.length >
                                  0 &&
                                  custodyWalletDetails?.custodyId?.length > 0 &&
                                  custodyWalletDetails?.custodyId?.toLowerCase() ===
                                    "hextrust" && (
                                    <>
                                      <img
                                        style={{
                                          maxHeight: "30px",
                                          maxWidth: "30px",
                                          overflow: "hidden",
                                          borderRadius: "40px",
                                        }}
                                        src={hexTrustIconBlue}
                                        alt=""
                                      />
                                      <p className="profile-popup-content-third-content-text">
                                        HexTrust (Institutional Custody)
                                      </p>
                                    </>
                                  )}
                                {Object.keys(custodyWalletDetails)?.length >
                                  0 &&
                                  custodyWalletDetails?.custodyId?.length > 0 &&
                                  custodyWalletDetails?.custodyId?.toLowerCase() !==
                                    "hextrust" && (
                                    <>
                                      <img
                                        style={{
                                          maxHeight: "30px",
                                          maxWidth: "30px",
                                          overflow: "hidden",
                                          borderRadius: "40px",
                                        }}
                                        src={walletConnectIcon}
                                        alt=""
                                      />
                                      <p className="profile-popup-content-third-content-text">
                                        {capitalizeFirstLetter(
                                          custodyWalletDetails?.custodyId,
                                        )}{" "}
                                        (Institutional Custody)
                                      </p>
                                    </>
                                  )}
                                {Object.keys(verifiedWalletDetails)?.length >
                                  0 &&
                                  verifiedWalletDetails?.address?.length >
                                    0 && (
                                    <>
                                      <img
                                        style={{
                                          maxHeight: "30px",
                                          maxWidth: "30px",
                                          overflow: "hidden",
                                          borderRadius: "40px",
                                        }}
                                        src={verifiedLogo}
                                        alt=""
                                      />
                                      <p className="profile-popup-content-third-content-text">
                                        Verified Wallet
                                      </p>
                                    </>
                                  )}
                                {Object.keys(verifiedWalletDetails)?.length ===
                                  0 &&
                                  Object.keys(custodyWalletDetails)?.length ===
                                    0 && (
                                    <>
                                      <img
                                        style={{
                                          maxHeight: "30px",
                                          maxWidth: "30px",
                                          overflow: "hidden",
                                          borderRadius: "40px",
                                        }}
                                        src={walletConnectIcon}
                                        alt=""
                                      />
                                      <p className="profile-popup-content-third-content-text">
                                        Other Wallets ({connector?.name})
                                      </p>
                                    </>
                                  )}
                              </div>
                            )}

                            {signedAccountId?.length > 0 &&
                              wallet &&
                              accounts?.length === 0 && (
                                <div className="profile-popup-content-third-content-text-container">
                                  <img
                                    style={{
                                      maxHeight: "30px",
                                      maxWidth: "30px",
                                      overflow: "hidden",
                                      borderRadius: "40px",
                                    }}
                                    src={wallet?.metadata?.iconUrl}
                                    alt=""
                                  />
                                  <p className="profile-popup-content-third-content-text">
                                    {wallet?.metadata?.name}
                                  </p>
                                </div>
                              )}

                            {accounts[0]?.address?.length > 0 &&
                              selectedWallet && (
                                <div className="profile-popup-content-third-content-text-container">
                                  <img
                                    style={{
                                      maxHeight: "30px",
                                      maxWidth: "30px",
                                      overflow: "hidden",
                                      borderRadius: "40px",
                                    }}
                                    src={selectedWallet?.icon}
                                    alt=""
                                  />
                                  <p className="profile-popup-content-third-content-text">
                                    {selectedWallet?.name}
                                  </p>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* <div className="profile-popup-content-second">
                      <p className="profile-popup-content-second-text">
                        Payment & Accounts
                      </p>
                      <div className="profile-popup-content-second-container">
                        <div
                          onClick={() => {
                            setCustomPortal("card");
                          }}
                          className="profile-popup-content-second-content"
                        >
                          <div className="profile-popup-content-second-content-icon">
                            <img src={accountIcon} alt="" />
                          </div>
                          <p className="profile-popup-content-second-content-text">
                            My Wallets
                          </p>
                        </div>

                        <div
                          onClick={() => {
                            setCustomPortal("card");
                          }}
                          className="profile-popup-content-second-content"
                        >
                          <div className="profile-popup-content-second-content-icon">
                            <img src={debitCard} alt="" />
                          </div>
                          <p className="profile-popup-content-second-content-text">
                            Debit Card
                          </p>
                        </div>

                        <div
                          onClick={() => {
                            setCustomPortal("card");
                          }}
                          className="profile-popup-content-second-content"
                        >
                          <div className="profile-popup-content-second-content-icon">
                            <img src={walletIcon} alt="" />
                          </div>
                          <p className="profile-popup-content-second-content-text">
                            Bank Accounts
                          </p>
                        </div>

                        <div
                          onClick={() => {
                            setCustomPortal("card");
                          }}
                          className="profile-popup-content-second-content"
                        >
                          <div className="profile-popup-content-second-content-icon">
                            <img src={demographyIcon} alt="" />
                          </div>
                          <p className="profile-popup-content-second-content-text">
                            Broker Accounts
                          </p>
                        </div>
                      </div>
                    </div> */}

                    <div className="profile-popup-content-third">
                      <p className="profile-popup-content-second-text">
                        Information
                      </p>
                      <div className="profile-popup-content-third-content-line"></div>
                      <div className="profile-popup-content-third-container">
                        <div
                          onClick={() => {
                            window.open("https://verified.network", "_blank");
                          }}
                          className="profile-popup-content-third-content"
                        >
                          <div className="profile-popup-content-third-content-text-container">
                            <img src={aboutIcon} alt="" />
                            <p className="profile-popup-content-third-content-text">
                              About Us
                            </p>
                          </div>
                          <img src={expandIcon} alt="Expand Icon" />
                        </div>
                        <div className="profile-popup-content-third-content-line"></div>

                        <div
                          onClick={() => {
                            window.open(
                              "https://discord.gg/maJKCM3VDS",
                              "_blank",
                            );
                          }}
                          className="profile-popup-content-third-content"
                        >
                          <div className="profile-popup-content-third-content-text-container">
                            <img src={questions} alt="" />
                            <p className="profile-popup-content-third-content-text">
                              Help & Support
                            </p>
                          </div>
                          <img src={expandIcon} alt="Expand Icon" />
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
                {customPortal === "settings" && (
                  <>
                    <p className="profile-popup-content-settings-text">
                      Privacy and Security
                    </p>
                    <div className="profile-popup-content-settings-container">
                      <div
                        onClick={() => {
                          if (
                            Object.values(props.verifiedWalletDetails)
                              ?.length === 0 &&
                            Object.values(props.custodyWalletDetails)
                              ?.length === 0 &&
                            address?.length > 0 &&
                            connector &&
                            !signedAccountId &&
                            accounts?.length === 0
                          ) {
                            disconnect({ connector: connector });
                            localStorage.removeItem("walletconnect"); // for WC v1
                            localStorage.removeItem("wc@2:client:0.3//session"); // for WC v2
                            resetUser();
                            resetNetwork();
                            if (setVerifiedWalletDetailsInt) {
                              setVerifiedWalletDetailsInt({});
                            }
                          } else if (
                            Object.values(props.verifiedWalletDetails)
                              ?.length === 0 &&
                            Object.values(props.custodyWalletDetails)
                              ?.length === 0 &&
                            !signedAccountId &&
                            accounts[0]?.address?.length > 0
                          ) {
                            disconnectSol();
                            resetUser();
                            resetNetwork();
                            return;
                          } else if (
                            Object.values(props.verifiedWalletDetails)
                              ?.length === 0 &&
                            Object.values(props.custodyWalletDetails)
                              ?.length === 0 &&
                            signedAccountId?.length > 0 &&
                            accounts?.length === 0
                          ) {
                            signOut();
                            resetUser();
                            resetNetwork();
                          } else if (
                            Object.values(props.verifiedWalletDetails)?.length >
                            0
                          ) {
                            localStorage.removeItem("VW:myVault");
                            resetUser();
                            resetNetwork();
                            if (setVerifiedWalletDetailsInt) {
                              setVerifiedWalletDetailsInt({});
                            }
                            window.location.href = window.location.origin;
                          } else if (
                            Object.values(props.custodyWalletDetails)?.length >
                            0
                          ) {
                            localStorage.removeItem("vHexT");
                            resetUser();
                            resetNetwork();
                            if (setVerifiedWalletDetailsInt) {
                              setVerifiedWalletDetailsInt({});
                            }
                            window.location.href = window.location.origin;
                          } else {
                            localStorage.removeItem("myVaultInt");
                            resetUser();
                            resetNetwork();
                            if (setVerifiedWalletDetailsInt) {
                              setVerifiedWalletDetailsInt({});
                            }
                            if (disconnectSol) {
                              disconnectSol();
                            }
                            window.location.href = window.location.origin;
                          }
                        }}
                        className="profile-popup-content-settings-second"
                      >
                        <div className="profile-popup-content-settings-first-text-container">
                          <img src={logoutIcon} alt="" />

                          <p className="profile-popup-content-settings-first-text-red">
                            Log Out
                          </p>
                        </div>

                        <img src={expandIcon} alt="" />
                      </div>

                      <div className="profile-popup-content-settings-line"></div>
                    </div>

                    <div className="profile-popup-content-settings-container">
                      <div
                        onClick={async () => {
                          const defaultLanguage = await getCurrentLanguageRaw();
                          props.setPopupContent(
                            <StartupLanguagePage
                              defaultLanguage={defaultLanguage}
                              setPopupContent={props.setPopupContent}
                              setPopupContentPosition={
                                props.setPopupContentPosition
                              }
                              setPageAction={props.setPageAction}
                              setShowPopup={props.setShowPopup}
                              refereshLanguage={refereshLanguage}
                              setRefereshLanguage={setRefereshLanguage}
                              isMobile={props.mobileScreen}
                            />,
                          );
                          props.setPopupContentPosition("center");
                          props.setPageAction("select-language");
                          props.setShowPopup(true);
                        }}
                        className="profile-popup-content-settings-second"
                      >
                        <div className="profile-popup-content-settings-first-text-container">
                          {/* <img src={logoutIcon} alt="" /> */}

                          <p className="profile-popup-content-settings-first-text">
                            Language: {"    "} {language}
                          </p>
                        </div>

                        <img src={expandIcon} alt="" />
                      </div>

                      <div className="profile-popup-content-settings-line"></div>
                    </div>
                  </>
                )}

                {customPortal === "card" && (
                  <React.Fragment>
                    <div className="profile-popup-card-header">
                      <div className="profile-popup-card-header-first">
                        <div className="profile-popup-card-header-first-container">
                          <div className="profile-popup-card-header-first-header">
                            <img
                              style={{
                                width: "235px",
                                height: "201px",
                                flexShrink: "0",
                              }}
                              className="g-s-content-overlay"
                              alt="Overlay"
                              src={overlayVector}
                            />
                            <img
                              style={{
                                width: "120px",
                              }}
                              className="g-s-content-overlay"
                              alt="Overlay"
                              src={overlayVector}
                            />
                            <p className="profile-popup-card-header-first-header-text">
                              SRINATH SANGVIKAR
                            </p>
                            <div className="profile-popup-card-header-first-header-label">
                              <p className="profile-popup-card-header-first-header-label-text">
                                8582
                              </p>
                              <p className="profile-popup-card-header-first-header-label-text">
                                1377
                              </p>
                              <p className="profile-popup-card-header-first-header-label-text">
                                9657
                              </p>
                              <p className="profile-popup-card-header-first-header-label-text">
                                3221
                              </p>
                            </div>
                          </div>

                          <div className="profile-popup-card-header-first-footer">
                            <div className="profile-popup-card-header-first-footer-first">
                              <div className="profile-popup-card-header-first-footer-first-body">
                                <p className="profile-popup-card-header-first-footer-first-body-text">
                                  Expires on
                                </p>

                                <p className="profile-popup-card-header-first-footer-first-body-label">
                                  02/22
                                </p>
                              </div>

                              <div className="profile-popup-card-header-first-footer-first-main">
                                <p className="profile-popup-card-header-first-footer-first-body-text">
                                  CVV
                                </p>

                                <p className="profile-popup-card-header-first-footer-first-body-label">
                                  272
                                </p>
                              </div>

                              <div className="profile-popup-card-header-first-footer-first-icon">
                                <img src={hideCvvIcon} alt="Hide CVV Icon" />
                              </div>
                            </div>

                            <img src={visaIcon} alt="Card Issuer Icon" />
                          </div>

                          <div className="profile-popup-card-header-second">
                            <div className="profile-popup-card-header-second-container">
                              <p className="profile-popup-card-header-second-text">
                                View Balance
                              </p>
                              <div className="profile-popup-card-header-second-label">
                                <p className="profile-popup-card-header-second-label-title">
                                  ₹
                                </p>
                                <p className="profile-popup-card-header-second-label-text">
                                  23,221
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="profile-popup-card-footer">
                      <div className="profile-popup-card-footer-container">
                        <p className="profile-popup-card-footer-text">
                          Card Actions
                        </p>
                        <div className="profile-popup-card-footer-body">
                          <div className="profile-popup-card-footer-body-content">
                            <p className="profile-popup-card-footer-body-text">
                              Reset PIN
                            </p>
                            <img src={expandIcon} alt="Expand Icon" />
                          </div>

                          <div className="profile-popup-card-footer-body-content">
                            <p className="profile-popup-card-footer-body-text">
                              Enable/Disable Wallets
                            </p>
                            <img src={toggleActive} alt="Expand Icon" />
                          </div>

                          <div className="profile-popup-card-footer-body-content">
                            <p className="profile-popup-card-footer-body-text">
                              Online Transactions
                            </p>
                            <img src={toggleActive} alt="Expand Icon" />
                          </div>

                          <div className="profile-popup-card-footer-body-content">
                            <p className="profile-popup-card-footer-body-text">
                              Tap and Pay Transactions
                            </p>
                            <img src={toggleActive} alt="Expand Icon" />
                          </div>

                          <div
                            style={{ paddingBottom: "0" }}
                            className="profile-popup-card-footer-body-content"
                          >
                            <p className="profile-popup-card-footer-body-text">
                              Cancel Card
                            </p>
                            <img src={toggleActive} alt="Expand Icon" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}

            {showProfileDetails && (
              <React.Fragment>
                <div className="profile-popup-show-details-header">
                  <div className="profile-popup-show-details-header-icon">
                    {userImageLink.length > 0 && (
                      <img src={userImageLink} alt="Profile Icon" />
                    )}
                    {userImageLink === "" && (
                      <Avatar name={userFullName.replace("undefined", "")} />
                    )}

                    <div className="profile-popup-show-details-header-icon-container">
                      <img
                        src={editIcon}
                        alt="Edit Icon"
                        className="profile-popup-clicakable-icon"
                      />
                    </div>
                  </div>

                  <div className="profile-popup-show-details-header-text-container">
                    {userFullName.replace("undefined", "").length > 0 && (
                      <p className="profile-popup-show-details-header-title">
                        {userFullName.replace("undefined", "")}
                      </p>
                    )}

                    {userFullName === "" && (
                      <p className="profile-popup-show-details-header-title">
                        No Name
                      </p>
                    )}

                    {Number(userKycStatus) === 3 && (
                      <div className="profile-popup-show-details-header-label-container">
                        <img src={verifiedIcon} alt="Verified Icon" />
                        <p className="profile-popup-show-details-header-label">
                          KYC Verified
                        </p>
                      </div>
                    )}
                    {Number(userKycStatus) !== 3 && (
                      <div className="profile-popup-show-details-header-label-container">
                        <p className="profile-popup-show-details-header-label">
                          KYC Not Verified
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                <div className="profile-popup-show-details-body">
                  <p className="profile-popup-show-details-body-title">
                    Personal Details
                  </p>
                  <div className="profile-popup-show-details-body-container">
                    <div className="profile-popup-show-details-body-content-first">
                      <div
                        style={{ width: "100%" }}
                        className="profile-popup-show-details-body-content-first-container"
                      >
                        <p className="profile-popup-show-details-body-content-first-title">
                          My Verified Wallet ID
                        </p>
                        <div
                          style={{
                            display: "inline-flex",
                            justifyContent: "space-between",
                            width: "100%",
                            flexDirection: "row",
                          }}
                        >
                          <p className="profile-popup-show-details-body-content-first-label">
                            {`${userAddress?.substring(
                              0,
                              8,
                            )}...${userAddress?.substring(
                              userAddress?.length - 10,
                              userAddress?.length,
                            )}`}
                          </p>
                          <img
                            style={{ cursor: "pointer" }}
                            onClick={async (e) => {
                              const target = e.currentTarget;
                              if (!target) return;
                              await navigator.clipboard
                                .writeText(userAddress)
                                .then(() => {
                                  showCustomAlert(target, "Copied");
                                })
                                .catch((err) => {
                                  console.error(
                                    "error while copying address: ",
                                    err,
                                  );
                                });
                            }}
                            src={copyIcon}
                            alt="Copy Icon"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="profile-popup-show-details-body-content-line"></div>

                    <div className="profile-popup-show-details-body-content-second">
                      <div className="profile-popup-show-details-body-content-first-container">
                        <p className="profile-popup-show-details-body-content-first-title">
                          Default Country of Registration
                        </p>
                        <p className="profile-popup-show-details-body-content-first-label">
                          {userCountry}
                        </p>
                      </div>
                    </div>

                    <div className="profile-popup-show-details-body-content-line"></div>

                    <div className="profile-popup-show-details-body-content-first">
                      <div className="profile-popup-show-details-body-content-first-container">
                        <p className="profile-popup-show-details-body-content-first-title">
                          Name ( As per govt ID )
                        </p>
                        {userFullName.replace("undefined", "").length > 0 && (
                          <p className="profile-popup-show-details-body-content-first-label">
                            {userFullName.replace("undefined", "")}
                          </p>
                        )}

                        {userFullName === "" && (
                          <p className="profile-popup-show-details-body-content-first-label">
                            No Name
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="profile-popup-show-details-body-content-line"></div>

                    <div className="profile-popup-show-details-body-content-first">
                      <div className="profile-popup-show-details-body-content-first-container">
                        <p className="profile-popup-show-details-body-content-first-title">
                          My Role
                        </p>
                        <p className="profile-popup-show-details-body-content-first-label">
                          {capitalizeFirstLetter(userRole)}
                        </p>
                      </div>
                    </div>

                    {userType.length > 0 && (
                      <div className="profile-popup-show-details-body-content-line"></div>
                    )}

                    {userType.length > 0 && (
                      <div className="profile-popup-show-details-body-content-first">
                        <div className="profile-popup-show-details-body-content-first-container">
                          <p className="profile-popup-show-details-body-content-first-title">
                            My Role Type
                          </p>
                          <p className="profile-popup-show-details-body-content-first-label">
                            {capitalizeFirstLetter(userType)}
                          </p>
                        </div>
                      </div>
                    )}

                    <div className="profile-popup-show-details-body-content-line"></div>

                    <div className="profile-popup-show-details-body-content-second">
                      <div className="profile-popup-show-details-body-content-first-container">
                        <p className="profile-popup-show-details-body-content-first-title">
                          Email Address
                        </p>
                        <p className="profile-popup-show-details-body-content-first-label">
                          {userEmail}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProfilePopup;
